export const RaikoUploaderStatus = {
    DONE : "DONE",
    IN_PROGRESS : "IN_PROGRESS",
    ABORTED : "ABORTED",
    CANCELED : "CANCELED",
}